import {AoaSheet, AxisMapped, ReportSheet, YAxisID} from "interfaces/report";
import { chain } from "lodash";
import { Line } from "react-chartjs-2";
import numeral from "numeral";

interface Props {
  sheet: ReportSheet<AxisMapped>;
}

export const MultiAxisChart = ({ sheet }: Props) => {
  sheet.yAxis = sheet.yAxis.filter((item) => !item.hide && item.active);

  const mergedYValue = chain(sheet.yAxis)
    .filter((item) => item.yAxisID === "y")
    .map("value")
    .uniq()
    .join(" | ")
    .value();

  const mergedY1Value = chain(sheet.yAxis)
    .filter((item) => item.yAxisID === "y1")
    .map("value")
    .uniq()
    .join(" | ")
    .value();

  console.log('---- sheet.yAxis:', sheet.yAxis);

  const data = {
    labels: sheet.xAxis.map((item) => item.value),
    datasets: sheet.yAxis.map((item) => {
      const color = item.color;
      const data = sheet.data
        .find((items) => items[0] === item.value)
        ?.slice(1) as AoaSheet;

      return {
        data,
        borderColor: color,
        label: item.value,
        backgroundColor: color + "80",
        yAxisID: item.yAxisID,
      };
    }),
  };

  return (
    <Line
      options={{
        responsive: true,
        interaction: {
          mode: "index" as const,
          intersect: false,
        },

        plugins: {
          datalabels: {
            display: false,
          },
          tooltip: {
            callbacks: {
              label(tooltipItem) {
                const value = tooltipItem.parsed.y;
                const yAxisID = tooltipItem.dataset.yAxisID as YAxisID;
                const unit = sheet.yAxis.find((axis) => axis.yAxisID === yAxisID)?.unit;

                let formatted = '';
                if (unit === '%') {
                  formatted = numeral(value).format('0.0%');
                } else if (unit === '$') {
                  formatted = numeral(value).format('$0,0.00');
                } else {
                  formatted = value.toLocaleString("en-AU", {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2
                  });
                }

                return `${tooltipItem.dataset.label}: ${formatted}`;
              },
            },
          },
          legend: {
            display: false,
          },
        },
        scales: {
          y: {
            ticks: {
              // Include a dollar sign in the ticks
              callback: function(value, index, ticks) {
                const unit = sheet.yAxis.find((axis) => axis.yAxisID === YAxisID.Y)?.unit;
                if (unit === '%') {
                  return numeral(value).format('0%');
                } else {
                  return numeral(value).format(`${unit}0.0a`);
                }
              }
            },
            type: "linear" as const,
            display: true,
            position: "left" as const,
            title: {
              display: true,
              text: mergedYValue,
            },
          },
          y1: {
            ticks: {
              // Include a dollar sign in the ticks
              callback: function(value, index, ticks) {
                const unit = sheet.yAxis.find((axis) => axis.yAxisID === YAxisID.Y1)?.unit;
                if (unit === '%') {
                  return numeral(value).format('0%');
                } else {
                  return numeral(value).format(`${unit}0.0a`);
                }
              }
            },
            type: "linear" as const,
            display: true,
            position: "right" as const,
            grid: {
              drawOnChartArea: false, // only want the grid lines for one axis to show up
            },
            title: {
              display: true,
              text: mergedY1Value,
            },
          },
        },
      }}
      data={data}
    />
  );
};
